<div class="logo-container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <img class="image" [ngClass]="{ 'is-portrait': isPortraitDevice }" [src]="'./assets/icons/il-verification.png'" />
</div>

<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="headlines">
        <span *ngIf="!isPortraitDevice" class="text-headline-title">
            {{ authTitle | translate }}
        </span>

        <span class="text-paragraph">
            {{ authSubtitle | translate }}
        </span>
    </div>

    <div class="list">
        <div class="feature">
            <div class="list-feature-box">
                <i class="ri-pass-valid-line"></i>
            </div>
            <div class="list-feature-text-box">
                <span class="text-paragraph-title">{{ authStep1 | translate }}</span>
            </div>
        </div>
        <div class="feature">
            <div class="list-feature-box">
                <i class="ri-wifi-line"></i>
            </div>
            <div class="list-feature-text-box">
                <span class="text-paragraph-title">{{ authStep2 | translate }}</span>
            </div>
        </div>
        <div class="feature">
            <div class="list-feature-box">
                <i class="ri-lightbulb-line"></i>
            </div>
            <div class="list-feature-text-box">
                <span class="text-paragraph-title">{{ authStep3 | translate }}</span>
            </div>
        </div>
    </div>

    <div class="actions">
        <button
            *ngIf="!isPortraitDevice"
            pripple=""
            class="button-secondary button-next"
            type="button"
            [disabled]="backButtonDisabled"
            (click)="onClicButtonBack()"
        >
            <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
            <span class="p-button-label-right">{{ backButton | translate }}</span>
        </button>

        <button
            pripple=""
            class="button-primary button-next"
            type="button"
            [disabled]="continueButtonDisabled"
            (click)="onClicButtonContinue()"
            [ngClass]="{ 'is-portrait': isPortraitDevice }"
        >
            <span class="p-button-label-left">{{ continueButton | translate }}</span>
            <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
        </button>
    </div>
</div>
